<template>
  <div class="o-program">

    <app-navigation
      :hideAuxNavOnDesktop="true"
      :currentSpace="$tc('web.program.nav_space', programs.length)"
    >
    </app-navigation>

    <main v-if="!access_denied" class="o-program__main">

      <router-link class="c-card c-card--program qa-program-card"
                   v-for="program in programs"
                   :to="{name: 'Program', params: { id: program.id }}"
                   :class="('t-program-card-' + program.id)"
                   :key="program.id">

        <div class="c-card--program__visual">
          <img :src="programImages[program.id].program_thm"
               :alt="$t('web.programs.alt_text_logo')"
               :srcset="programImages[program.id].program_thm + ' 160w, ' +
                       programImages[program.id].program_thm_350 + ' 350w, ' +
                       programImages[program.id].program_thm_700 + ' 700w'">
        </div>

        <div class="c-card--program__info t-program-id__info">
          <h2 class="c-card--program__info__title t-program-id__info__title">{{ program.name }}</h2>
          <p class="c-card--program__info__desc t-program-id__info__desc">{{ program.description }}</p>
        </div>

      </router-link>

    </main>

    <main class="o-program__main" v-else>
        <h1 class="c-card--program-header__info__title t-program__info__title">{{ $t('web.program_dashboard.no_access') }}</h1>
    </main>


    <app-footer></app-footer>



  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProgramDashboard',

  data () {
    return {
      access_denied: false
    }
  },

  computed: {
    ...mapGetters([
      'programDashboard',
      'websiteConfig',
      'programImages'
    ]),
    programs () {
      return this.programDashboard.programs
    }
  },

  mounted () {
    this.LOAD_PROGRAM_DASHBOARD(this.$route.params.id)
        .then(data => {
          /** Redirect if there's only one program */
          if (data.data.programs.length === 1) {
            this.$router.push({name: 'Program', params: { id: data.data.programs[0].id }})
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({name: 'NotFound'})
          }

          this.access_denied = error.response.status === 403
        })
  },

  methods: {
    ...mapActions([
      'LOAD_PROGRAM_DASHBOARD'
    ])
  }
}

</script>



// WEBPACK FOOTER //
// ProgramDashboard.vue?6c29e201